module.exports = __webpack_public_path__ + "img/setting-active.4089596c.png";